import {DashboardTileSize} from '../types/DashboardTileSize';

export const DASHBOARD_TILE_SIZE_LABELS: Record<DashboardTileSize, string> = {
  quarter: 'page.homepage.dashboardLayout.sizeQuarter',
  half: 'page.homepage.dashboardLayout.sizeSmall',
  tall: 'page.homepage.dashboardLayout.sizeTall',
  wide: 'page.homepage.dashboardLayout.sizeWide',
  large: 'page.homepage.dashboardLayout.sizeLarge',
};
